import { Flag as FlagIcon } from '@material-ui/icons';
import React from 'react';
import { useIntl } from 'react-intl';
import AccessControlledButton from '../AccessControlledButton';
import messages from './messages';

function GuideTours({ tours, setIsOpen }) {
  const intl = useIntl();

  return (
    <div className="mr-5">
      <div className="text-2xl font-bold text-slate-800">{intl.formatMessage(messages.tours)}</div>
      <div className="text-sm font-medium text-slate-400 mb-5">
        {intl.formatMessage(messages.toursSubHeader)}
      </div>
      <div className="text-sm font-semibold text-slate-700">
        {intl.formatMessage(messages.yourTours)}
      </div>
      <div className="min-h-[72px] flex items-center px-4 py-6 my-8 mx-auto rounded-2xl bg-white border border-solid border-slate-200 shadow-sm w-[90%]">
        {tours?.length ? (
          <div className="flex flex-col">
            {tours.map((tour, index) => {
              return (
                <div
                  key={index}
                  className="text-xs font-bold text-slate-700 flex items-center mb-4 last:mb-0"
                >
                  <div className="bg-slate-100 text-slate-500 w-8 h-8 rounded-full mr-2.5 flex justify-center items-center shrink-0">
                    <FlagIcon />
                  </div>
                  {tour.title}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-slate-400">{intl.formatMessage(messages.toursEmptyStateMessage)}</div>
        )}
      </div>
      <AccessControlledButton
        feature={'PostTipReviewCollection'}
        title={intl.formatMessage(messages.selectTours)}
        onClick={() => setIsOpen(true)}
        elementStyle="w-full"
        withIcon={false}
      />
    </div>
  );
}

export default GuideTours;
